import React from "react";
import PropTypes from "prop-types";

import { useSiteMetadata } from "../hooks/useSiteMetadata";

const InfoEmailLink = ({ className }) => {
    const { infoEmail } = useSiteMetadata();
    if (!infoEmail) {
        return null;
    }

    return (
        <a href={`mailto:${infoEmail}`} className={className}>
            {infoEmail}
        </a>
    );
};

InfoEmailLink.propTypes = {
    className: PropTypes.string,
};

export default InfoEmailLink;
